import { render, staticRenderFns } from "./modalSeleccionar.vue?vue&type=template&id=06ca3635&scoped=true&"
import script from "./modalSeleccionar.vue?vue&type=script&lang=js&"
export * from "./modalSeleccionar.vue?vue&type=script&lang=js&"
import style0 from "./modalSeleccionar.vue?vue&type=style&index=0&id=06ca3635&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca3635",
  null
  
)

export default component.exports